import script from "./RefugeAssocie.vue?vue&type=script&setup=true&lang=js"
export * from "./RefugeAssocie.vue?vue&type=script&setup=true&lang=js"

import "../assets/css/refugeassocie.css?vue&type=style&index=0&id=67fa7624&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67fa7624"]])

export default __exports__